import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faq } from "@/mocks/homeContent";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <SectionHeading kicker="FAQ" title={faq.title} desc={faq.desc} />

          <div className="space-y-3">
            {faq.list.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q} className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="flex w-full items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-background-200/50"
                    >
                      <span className="flex-1 font-heading text-sm font-semibold text-foreground-900 md:text-base">
                        {item.q}
                      </span>
                      <i
                        className={`${
                          isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                        } shrink-0 text-xl text-primary-500`}
                      ></i>
                    </button>
                  </h3>
                  <p
                    className={
                      isOpen
                        ? "border-t border-background-200/70 px-5 py-4 text-sm leading-7 text-foreground-600"
                        : "hidden"
                    }
                  >
                    {item.a}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}